export default {
  handprintView: {
    large: 'Grande',
    melody: 'Mélodie',
    instructions: {
      leftHandOneByOne: "Jouez la main gauche une note après l'autre.",
      leftHandTogether: 'Jouez toutes les notes de la main gauche en même temps.',
      rightHandOneByOne: "Jouez la main droite une note après l'autre.",
      rightHandTogether: 'Jouez toutes les notes de la main droite en même temps.',
      bothHandsOneByOne: "Jouez les notes de bas en haut, une note après l'autre",
      rightTogetherThenLeft: "Jouez les notes de la main droite en même temps puis, en restant appuyé, jouez la main gauche une note après l'autre.",
      leftTogetherThenRight: "Jouez les notes de la main gauche en même temps puis, en restant appuyé, jouez la main droite une note après l'autre.",
      bothHandsTogether: 'Jouez les notes de la main gauche et de la main droite en même temps.',
    },
  },
};
